'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'user-astronaut';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f4fb';
var svgPathData = ['M112 144c0-26.5 21.5-48 48-48H288c26.5 0 48 21.5 48 48v16c0 53-43 96-96 96H208c-53 0-96-43-96-96V144zm77.3 18.7l-6-21.2c-.9-3.3-3.9-5.5-7.3-5.5s-6.4 2.2-7.3 5.5l-6 21.2-21.2 6c-3.3 .9-5.5 3.9-5.5 7.3s2.2 6.4 5.5 7.3l21.2 6 6 21.2c.9 3.3 3.9 5.5 7.3 5.5s6.4-2.2 7.3-5.5l6-21.2 21.2-6c3.3-.9 5.5-3.9 5.5-7.3s-2.2-6.4-5.5-7.3l-21.2-6zM160 416H288c17.7 0 32 14.3 32 32v64H192V464c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H128V448c0-17.7 14.3-32 32-32zm128 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z', 'M224 0c65.7 0 122.1 39.5 146.7 96.1C387.1 97.5 400 111.2 400 128v64c0 16.8-12.9 30.5-29.3 31.9C346.1 280.5 289.7 320 224 320s-122.1-39.5-146.7-96.1C60.9 222.5 48 208.8 48 192V128c0-16.8 12.9-30.5 29.3-31.9C101.9 39.5 158.3 0 224 0zM336 160V144c0-26.5-21.5-48-48-48H160c-26.5 0-48 21.5-48 48v16c0 53 43 96 96 96h32c53 0 96-43 96-96zM112.7 316.5C144.1 338.8 182.5 352 224 352s79.9-13.2 111.3-35.5C401.3 342.6 448 407 448 482.3c0 16.4-13.3 29.7-29.7 29.7L320 512V448c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32v64H29.7C13.3 512 0 498.7 0 482.3C0 407 46.7 342.6 112.7 316.5z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUserAstronaut = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;